/* Synonym groups for storefront search — window.VinoSynonymsFile.
 *
 * One group per line, members separated by commas. A group is symmetric:
 * typing any member searches for all of them. A member may be several words
 * ("pinot gris"), which is matched as a phrase.
 *
 * This file exists because Shopify's Search & Discovery synonyms tab
 * disappeared from the admin in September 2026 — no changelog entry, no Shopify
 * statement, and no way to export what was in it: there is no synonym type in
 * the Admin API on any version, no shop metafield holding them (the only
 * shopify--discovery--* definitions are product-level recommendations and
 * search boosts), and Matrixify covers those metafields but not synonyms.
 *
 * The native feature capped out at 1000 synonyms per shop, 20 per group.
 * This file has no ceiling, is reviewed like code, and cannot be withdrawn.
 * Small corrections can still be made in the theme settings without a deploy;
 * both sources are read and concatenated by groups() in search-and-terms.js.
 *
 * Grow this list from Search & Discovery analytics -> "searches with no
 * results". That report is what the original thousands of groups were built
 * from, and it is still there.
 */
window.VinoSynonymsFile = [
  "rulandské šedé, pinot gris, pinot grigio",
  "rulandské biele, pinot blanc, weissburgunder",
  "rulandské modré, pinot noir, spätburgunder",
  "burgundsko, burgundské, burgundský, bourgogne",
  "veltlínske zelené, grüner veltliner",
  "frankovka, frankovka modrá, blaufränkisch, lemberger",
  "tramín, tramín červený, gewürztraminer, traminer",
  "rizling rýnsky, riesling",
  "rizling vlašský, vlašský, welschriesling",
  "sauvignon, sauvignon blanc",
  "bordeaux, bordó",
  "šedé, gris, grigio, grauburgunder",
  "svätovavrinecké, svatovavrinecke, st laurent, saint laurent",
  "châteauneuf-du-pape, chateauneuf du pape, cdp",
  "beerenauslese, trockenbeerenauslese, tba",
  "aszú, aszu, assu, azsu, výber putňový, putňový, putnovy",
  "ribera del duero, ribera duero, rdd",
  "ripasso, valpolicella ripasso",
  "brunello, brunello di montalcino",
  "tokajské, tokajske, tokaj",
].join('\n');
